import {
  LANG_DE,
  LANG_EN,
  LANG_ES,
  LANG_FR,
  LANG_IT,
} from '../../core/lang/constants';


const TEMPLATE_ID_SP_RIV = 'sp_riv';
const TEMPLATE_ID_SP_RIV_NEW = 'sp_riv_new';
const TEMPLATE_ID_SP_NUDEINCAM = 'sp_nudeincam';
const TEMPLATE_ID_SP_CHICAS = 'sp_chicas';
const TEMPLATE_ID_SP_REDVALENTINE = 'sp_redvalentine';
const TEMPLATE_ID_SP_RIVFETISH = 'sp_rivfetish';
const TEMPLATE_ID_SP_RIVBOYS = 'sp_rivboys';
const TEMPLATE_ID_SP_RIVTUBE = 'sp_rivtube';
const TEMPLATE_ID_SP_ISEEXYOU = 'sp_iseexyou';
const TEMPLATE_ID_SP_ONLYFEET = 'sp_onlyfeet';

export const templatesNameLangkeys = {
  [TEMPLATE_ID_SP_RIV]: 'msg.wl-template.single-page',
  [TEMPLATE_ID_SP_RIV_NEW]: 'msg.wl-template.single-page.dark',
  [TEMPLATE_ID_SP_NUDEINCAM]: 'msg.wl-template.single-page',
  [TEMPLATE_ID_SP_CHICAS]: 'msg.wl-template.single-page',
  [TEMPLATE_ID_SP_REDVALENTINE]: 'msg.wl-template.single-page',
  [TEMPLATE_ID_SP_RIVFETISH]: 'msg.wl-template.single-page',
  [TEMPLATE_ID_SP_RIVBOYS]: 'msg.wl-template.single-page',
  [TEMPLATE_ID_SP_RIVTUBE]: 'msg.wl-template.single-page',
  [TEMPLATE_ID_SP_ISEEXYOU]: 'msg.wl-template.single-page',
  [TEMPLATE_ID_SP_ONLYFEET]: 'msg.wl-template.single-page',
};

const PATH_TO_TEMPLATES_PREVIEWS = '/static/images/landing';
export const templatePreviewSrcLangMap = {
  [TEMPLATE_ID_SP_RIV]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_riv.jpg`,
  },
  [TEMPLATE_ID_SP_RIV_NEW]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_riv_new.jpg`,
  },
  [TEMPLATE_ID_SP_NUDEINCAM]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_nudeincam.jpg`,
  },
  [TEMPLATE_ID_SP_CHICAS]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_chicasenventa.jpg`,
  },
  [TEMPLATE_ID_SP_REDVALENTINE]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_redvalentine.jpg`,
  },
  [TEMPLATE_ID_SP_RIVFETISH]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_rivfetish.jpg`,
  },
  [TEMPLATE_ID_SP_RIVBOYS]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_rivboys.jpg`,
  },
  [TEMPLATE_ID_SP_RIVTUBE]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_rivtube.jpg`,
  },
  [TEMPLATE_ID_SP_ISEEXYOU]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_iseexyou.jpg`,
  },
  [TEMPLATE_ID_SP_ONLYFEET]: {
    [LANG_IT]: `${PATH_TO_TEMPLATES_PREVIEWS}/preview_large_onlyfeet.jpg`,
  },
};

export const defaultTemplatePreviewLangsMap = {
  [TEMPLATE_ID_SP_RIV]: LANG_IT,
  [TEMPLATE_ID_SP_RIV_NEW]: LANG_IT,
  [TEMPLATE_ID_SP_NUDEINCAM]: LANG_IT,
  [TEMPLATE_ID_SP_CHICAS]: LANG_IT,
  [TEMPLATE_ID_SP_REDVALENTINE]: LANG_IT,
  [TEMPLATE_ID_SP_RIVFETISH]: LANG_IT,
  [TEMPLATE_ID_SP_RIVBOYS]: LANG_IT,
  [TEMPLATE_ID_SP_RIVTUBE]: LANG_IT,
  [TEMPLATE_ID_SP_ISEEXYOU]: LANG_IT,
  [TEMPLATE_ID_SP_ONLYFEET]: LANG_IT,
};

export const translationLangsOrder = [
  LANG_IT,
  LANG_EN,
  LANG_DE,
  LANG_FR,
  LANG_ES,
];
